import * as z from 'zod';
import { SYSTEM_SETTINGS_CATEGORY, SYSTEM_SETTINGS_CODE } from 'src/features/systems/utils/types';

export type DisplaySettingCreateFormSchemaValues = z.infer<typeof displaySettingCreateFormSchema>;
export type DisplaySettingFormSchemaValues = z.infer<typeof displaySettingFormSchema>;

const displaySettingValue = z.object({
    title: z.string().optional(),
    subtitle: z.string().optional(),
    title_color: z.string().optional(),
    subtitle_color: z.string().optional(),
});

export const displaySettingCreateFormSchema = z.object({
    category: z.enum(SYSTEM_SETTINGS_CATEGORY),
    code: z.enum(SYSTEM_SETTINGS_CODE),
    value: displaySettingValue,
});

export const displaySettingFormSchema = z.object({
    successful_entrance_message: displaySettingValue,
    rejected_entrance_message: displaySettingValue,
    successful_exit_message: displaySettingValue,
    rejected_exit_message: displaySettingValue,
    date_message: displaySettingValue,
    spaces_message: displaySettingValue,
    lpr_message: displaySettingValue,
    ticket_message: displaySettingValue,
    card_message: displaySettingValue,
});
